import React from "react";
import {
  getFilteredFunctionList,
  parameterTypes,
  passthroughParameterTypes,
} from "../../../utils";
import MapperFunction from "./MapperFunction";
import functionList from "./../../Payroll/MapandTransformContainer/FunctionList";

const TargetHeaderSection = (props) => {
  const {
    fields,
    setClickToSelect,
    setFieldArrayName,
    hasHeader,
    headerError,
    valueError,
    mapType,
  } = props;

  return (
    <div className="mapper-target-container mt-30 ml-3">
      <MapperFunction
        functionList={getFilteredFunctionList(1, true) || []}
        fields={fields}
        isHeader={true}
        hasHeader={hasHeader}
        parameterTypes={
          mapType == 3 ? passthroughParameterTypes : parameterTypes
        }
        setClickToSelect={setClickToSelect}
        setFieldArrayName={setFieldArrayName}
        headerError={headerError}
        valueError={valueError}
      />
    </div>
  );
};

export default TargetHeaderSection;
